import { useEffect, useState } from 'react';
import { useAuth } from 'react-oidc-context';
import { getPatientOrders } from '../service';
import { useParams } from 'react-router-dom';
import {
  DateFilter,
  PatientOrderDataResponse,
  PatientOrderHookReturn,
  PatientOrderResponse,
} from '../interface/interface';
import moment from 'moment';

const usePatientOrdersActions = (): PatientOrderHookReturn => {
  const { patientId } = useParams();
  const { user } = useAuth();
  const [loading, setLoading] = useState<boolean>(false);
  const [orders, setOrders] = useState<Array<PatientOrderDataResponse>>([]);
  const [total, setTotal] = useState<number>(0);
  const [search, setSearch] = useState<string>('');
  const [isSearchSubmitted, setSearchSubmissionStatus] = useState<number>(0);
  const [monthRange, setMonthRange] = useState<[DateFilter, DateFilter]>([
    null,
    null,
  ]);

  useEffect(() => {
    if (!user?.access_token || !patientId) {
      return;
    }

    setLoading(true);
    getPatientOrders(
      user.access_token,
      patientId,
      search,
      moment(monthRange?.[0]).isValid()
        ? moment(monthRange[0]).format('DD-MM-YYYY')
        : '',
      moment(monthRange?.[1]).isValid()
        ? moment(monthRange?.[1]).format('DD-MM-YYYY')
        : '',
    )
      .then((data: PatientOrderResponse) => {
        setOrders(data.data);
        setTotal(data.total);
      })
      .catch((err) => {
        console.error('Failed to fetch patient orders:', err);
        setOrders([]);
        setTotal(0);
      });
    setLoading(false);
  }, [user?.access_token, isSearchSubmitted, monthRange]);

  return [
    loading,
    total,
    orders,
    {
      value: search,
      changeHandler: setSearch,
      submitSearch: setSearchSubmissionStatus,
    },
    {
      monthRange,
      setMonthRange,
    },
  ];
};

export default usePatientOrdersActions;
